<template>
  <div class="header">
    <div class="logo">
      <a href="https://www.ey-parthenon.de">
        <img alt="Parthenon" src="../../assets/logo.jpg">
      </a>
    </div>

    <div class="header-container">
      <p>SPURS | Strategic Planning Uncertainty Reduction Solution</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Header',
  props: { }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .header {
    flex: 0 1 auto;
  }
  .logo img {
    float: left;
    padding: 15px 20px;
    height: 30px;
  }
  .header-container {
    overflow: auto;
  }
  p {
    float: left;
    padding: 10px;
    font-weight: bold;
    margin: 8px;
    font-size: 20px;
    color: #4B4B4B;
  }
</style>
